<p-toast />
<p-confirmDialog />
<p-confirmDialog key="gaps-warning" [style]="{ width: '40rem' }" />

<div class="w-full h-full">
  <!-- CARD PRINCIPAL -->
  <div class="bg-white border border-gray-200 rounded-xl shadow-sm h-full flex flex-col">

    <!-- HEADER -->
    <div class="px-6 py-5 border-b border-gray-100 flex items-center justify-between bg-white">
      <div class="flex items-center gap-4">
        <p-button
          icon="pi pi-arrow-left"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          (onClick)="onStepBack()"
          pTooltip="Volver"
          tooltipPosition="bottom"
        />
        <h1 class="text-2xl font-bold text-gray-800 tracking-tight m-0">
          {{ isEditMode() ? 'Editar' : 'Nueva' }} Configuración de Precios
        </h1>
      </div>

      <p-button
        label="Guardar"
        icon="pi pi-check"
        (onClick)="onSubmit()"
        [disabled]="!isFormValid()"
        severity="primary"
      />
    </div>

    <!-- CONTENIDO -->
    <div class="p-8">
      @if (loadingData()) {
        <div class="space-y-8">
          <div class="grid grid-cols-2 gap-6">
            <p-skeleton height="3rem" />
            <p-skeleton height="3rem" />
          </div>
          <div class="grid grid-cols-2 gap-6">
            <p-skeleton height="3rem" />
            <p-skeleton height="3rem" />
          </div>
          <p-skeleton height="20rem" />
        </div>
      } @else {
        <!-- SECCIÓN 1: IDENTIFICADORES -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 mb-8 pt-4">

          <!-- Nombre de la configuración -->
          <div class="field">
            <p-floatlabel variant="on">
              <input
                pInputText
                id="name"
                [(ngModel)]="configName"
                (blur)="markAsTouched('name')"
                class="w-full"
                autocomplete="off"
                placeholder="Ingrese el nombre de la configuración"
                [maxlength]="255"
              />
              <label for="name">
                Nombre de Configuración <span class="text-red-500">*</span>
              </label>
            </p-floatlabel>
            @if (isConfigNameInvalid()) {
              <small class="text-red-500 block mt-1 pl-1">
                Este campo es obligatorio
              </small>
            }
          </div>

          <!-- Zona Horaria -->
          <div class="field">
            <p-floatlabel variant="on">
              <p-select
                inputId="timezone"
                [(ngModel)]="selectedTimezone"
                [options]="timezoneOptions()"
                (onBlur)="markAsTouched('timezone')"
                optionLabel="label"
                optionValue="value"
                class="w-full"
                placeholder="Seleccione la zona horaria"
                [filter]="true"
                filterBy="label"
                appendTo="body"
              />
              <label for="timezone">
                Zona Horaria <span class="text-red-500">*</span>
              </label>
            </p-floatlabel>
            @if (isTimezoneInvalid()) {
              <small class="text-red-500 block mt-1 pl-1">
                Este campo es obligatorio
              </small>
            }
          </div>

          <!-- Zona Comercial -->
          <div class="field">
            <p-floatlabel variant="on">
              <p-select
                inputId="commercialZone"
                [(ngModel)]="selectedCommercialZone"
                [options]="commercialZoneOptions()"
                (onBlur)="markAsTouched('commercialZone')"
                optionLabel="label"
                optionValue="value"
                class="w-full"
                placeholder="Seleccione la zona comercial"
                [filter]="true"
                filterBy="label"
                appendTo="body"
              />
              <label for="commercialZone">
                Zona Comercial <span class="text-red-500">*</span>
              </label>
            </p-floatlabel>
            @if (isCommercialZoneInvalid()) {
              <small class="text-red-500 block mt-1 pl-1">
                Este campo es obligatorio
              </small>
            }
          </div>

          <!-- Condición Comercial -->
          <div class="field">
            <p-floatlabel variant="on">
              <p-select
                inputId="commercialCondition"
                [(ngModel)]="selectedCommercialCondition"
                [options]="commercialConditionOptions()"
                (onBlur)="markAsTouched('commercialCondition')"
                optionLabel="label"
                optionValue="value"
                class="w-full"
                placeholder="Seleccione la condición comercial"
                [filter]="true"
                filterBy="label"
                appendTo="body"
              />
              <label for="commercialCondition">
                Condición Comercial <span class="text-red-500">*</span>
              </label>
            </p-floatlabel>
            @if (isCommercialConditionInvalid()) {
              <small class="text-red-500 block mt-1 pl-1">
                Este campo es obligatorio
              </small>
            }
          </div>

        </div>

        <!-- SECCIÓN 2: VIGENCIA Y ACTIVACIÓN -->
        <div class="mt-4 mb-8">

          <!-- Porcentaje de Impuesto y Estado -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-10 mb-6">
            <div>
              <p-floatlabel variant="on">
                <p-inputnumber
                  inputId="taxPercentage"
                  [(ngModel)]="taxPercentage"
                  (onBlur)="markAsTouched('taxPercentage')"
                  mode="decimal"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [min]="0"
                  [max]="100"
                  suffix="%"
                  class="w-full"
                />
                <label for="taxPercentage">
                  Porcentaje de Impuesto <span class="text-red-500">*</span>
                </label>
              </p-floatlabel>
              @if (isTaxPercentageInvalid()) {
                <small class="text-red-500 block mt-1 pl-1">
                  Este campo es obligatorio
                </small>
              }
            </div>
            <div class="flex items-center">
              <div class="flex items-center gap-4">
                <p-toggleswitch [ngModel]="isActive()" (ngModelChange)="isActive.set($event)" />
                <span class="text-sm font-medium text-gray-600">
                  {{ isActive() ? 'Configuración de precios activa' : 'Configuración de precios inactiva' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Fecha de Inicio y Checkbox -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-10 mb-6">
            <div>
              <p-floatlabel variant="on">
                <p-datepicker
                  inputId="startDate"
                  [(ngModel)]="validityStartDate"
                  (onBlur)="markAsTouched('startDate')"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  appendTo="body"
                  class="w-full"
                />
                <label for="startDate">
                  Fecha de Inicio <span class="text-red-500">*</span>
                </label>
              </p-floatlabel>
              @if (isStartDateInvalid()) {
                <small class="text-red-500 block mt-1 pl-1">
                  Este campo es obligatorio
                </small>
              }
            </div>

            <div class="flex items-center">
              <div class="flex items-center gap-3">
                <p-checkbox
                  [(ngModel)]="hasEndDate"
                  [binary]="true"
                  inputId="hasEndDate"
                />
                <label for="hasEndDate" class="text-sm font-medium text-gray-700 cursor-pointer">
                  Configurar fecha de fin
                </label>
              </div>
            </div>
          </div>

          <!-- Fecha de Fin (visible solo si hasEndDate es true) -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-10 mb-6" [class.hidden]="!hasEndDate()">
            <div>
              <p-floatlabel variant="on">
                <p-datepicker
                  inputId="endDate"
                  [(ngModel)]="validityEndDate"
                  (onBlur)="markAsTouched('endDate')"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  [minDate]="minEndDate()"
                  appendTo="body"
                  class="w-full"
                />
                <label for="endDate">
                  Fecha de Fin <span class="text-red-500">*</span>
                </label>
              </p-floatlabel>
              @if (isEndDateInvalid()) {
                <small class="text-red-500 block mt-1 pl-1">
                  Este campo es obligatorio
                </small>
              }
            </div>
            <div></div>
          </div>
        </div>

        <!-- SECCIÓN 3: PRECIOS POR DÍA Y HORARIO (Condicional) -->
        @if (identifiersComplete()) {
          <div class="mb-8">
            <div class="flex items-center justify-between mb-4">
              <h2 class="text-xl font-semibold text-gray-800">Precios por Día y Horario</h2>
              <button
                pButton
                label="Agregar Horario"
                icon="pi pi-plus"
                (click)="addTimeSlot()"
                severity="secondary"
                size="small"
              ></button>
            </div>

            <!-- Matriz de precios -->
            <div class="overflow-x-auto border border-gray-200 rounded-lg">
              <table class="w-full min-w-max border-collapse price-matrix-table">
                <thead>
                  <tr class="bg-gray-50">
                    <th class="border border-gray-300 px-3 py-3 text-left font-semibold text-gray-700 min-w-[13rem]">Horario</th>
                    @for (dayLabel of daysLabels; track $index) {
                      <th class="border border-gray-300 px-2 py-3 text-center font-semibold text-gray-700 min-w-[1.5rem]">
                        {{ dayLabel }}
                      </th>
                    }
                    <th class="border border-gray-300 px-3 py-3 text-center font-semibold text-gray-700 min-w-[6rem]">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of priceMatrix(); track row.id) {
                    <tr class="hover:bg-gray-50">
                    <!-- Columna de horario -->
                    <td class="border border-gray-300 px-3 py-2 min-w-[13rem]">
                      <div class="flex items-center gap-2">
                        <input
                          type="time"
                          [(ngModel)]="row.startTime"
                          (ngModelChange)="onTimeChange(row.id, 'startTime', $event)"
                        />
                        <span class="text-gray-400">-</span>
                        <input
                          type="time"
                          [(ngModel)]="row.endTime"
                          (ngModelChange)="onTimeChange(row.id, 'endTime', $event)"
                        />
                      </div>
                    </td>

                    <!-- Celdas de precios por día -->
                    @for (day of daysOfWeek; track day) {
                      <td
                        class="border border-gray-300 px-1 py-2 min-w-[1.5rem]"
                        (dragover)="onDragOver($event)"
                        (drop)="onDrop(row.id, day)"
                      >
                        <p-inputnumber
                          [(ngModel)]="row.prices[day]"
                          mode="decimal"
                          [minFractionDigits]="2"
                          [maxFractionDigits]="2"
                          [min]="0"
                          [step]="0.01"
                          prefix="$"
                          locale="es-MX"
                          class="w-full"
                          [draggable]="true"
                          (dragstart)="onDragStart(row.prices[day])"
                        />
                      </td>
                    }

                    <!-- Columna de acciones -->
                    <td class="border border-gray-300 px-2 py-2 min-w-[6rem]">
                      <div class="flex gap-2 justify-center items-center">
                        <button
                          pButton
                          icon="pi pi-arrow-right"
                          [text]="true"
                          size="small"
                          pTooltip="Aplicar a fila"
                          tooltipPosition="top"
                          (click)="applyToRow(row.id, row.prices['lunes'])"
                          severity="secondary"
                        ></button>
                        <button
                          pButton
                          icon="pi pi-trash"
                          [text]="true"
                          size="small"
                          severity="danger"
                          pTooltip="Eliminar fila"
                          tooltipPosition="top"
                          (click)="removeTimeSlot(row.id)"
                          [disabled]="priceMatrix().length === 1"
                        ></button>
                      </div>
                    </td>
                    </tr>
                  }

                  <!-- Fila de aplicar a columna -->
                  <tr class="bg-gray-100">
                    <td class="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 min-w-[13rem]">
                      Aplicar a columna
                    </td>
                    @for (day of daysOfWeek; track day) {
                      <td class="border border-gray-300 px-1 py-2 text-center min-w-[1.5rem]">
                        <button
                          pButton
                          icon="pi pi-arrow-down"
                          [text]="true"
                          size="small"
                          pTooltip="Aplicar precio a toda la columna"
                          tooltipPosition="top"
                          (click)="applyToColumn(day, priceMatrix()[0] ? priceMatrix()[0].prices[day] : 0)"
                          severity="secondary"
                        ></button>
                      </td>
                    }
                    <td class="border border-gray-300 min-w-[6rem]"></td>
                  </tr>
                </tbody>
              </table>
            </div>

            @if (!timeSlotValidation().valid) {
              <div class="mt-3 text-sm text-red-600">
                @for (error of timeSlotValidation().errors; track $index) {
                  <div>• {{ error }}</div>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
</div>

